// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2oAqw","productName":"Table_productName__2jg9G"};